import React from "react";
import { useSiteData } from "../context/SiteDataContext";
import defaultBooksData from "../data/books.json";
import defaultHeroData from "../data/hero.json";

const Booksv1New = ({ isBg }) => {
  const { data, loading } = useSiteData();
  const booksNew = data?.booksNew || defaultBooksData.booksNew;
  const herov2New = data?.herov2New || defaultHeroData.herov2New;

  if (loading) return null;

  // Get images array - support both new format (images array) and old format (image1-4)
  const getImages = () => {
    if (booksNew.images && booksNew.images.length > 0) {
      return booksNew.images.filter(img => img && img.trim() !== '');
    }
    // Fallback to old format
    const oldImages = [booksNew.image1, booksNew.image2, booksNew.image3, booksNew.image4];
    return oldImages.filter(img => img && img.trim() !== '');
  };

  const images = getImages();
  const imageCount = images.length;

  // Render images based on count
  const renderImages = () => {
    if (imageCount === 0) return null;

    if (imageCount === 1) {
      // Single image - full width centered
      return (
        <div className="row justify-content-center">
          <div className="col-8">
            <div className="booksv1__img--single">
              <img className="img-fluid" src={images[0]} alt="Book" />
            </div>
          </div>
        </div>
      );
    }

    if (imageCount === 2) {
      // Two images side by side
      return (
        <div className="row">
          <div className="col-6">
            <div className="booksv1__img">
              <img className="img-fluid" src={images[0]} alt="Book" />
            </div>
          </div>
          <div className="col-6">
            <div className="booksv1__img">
              <img className="img-fluid" src={images[1]} alt="Book" />
            </div>
          </div>
        </div>
      );
    }

    if (imageCount === 3) {
      // Three images - 2 on left column, 1 large on right
      return (
        <div className="row">
          <div className="col-6">
            <div className="booksv1__img--wrap">
              <div className="booksv1__img">
                <img className="img-fluid" src={images[0]} alt="Book" />
              </div>
              <div className="booksv1__img">
                <img className="img-fluid" src={images[1]} alt="Book" />
              </div>
            </div>
          </div>
          <div className="col-6 d-flex align-items-center">
            <div className="booksv1__img booksv1__img--large">
              <img className="img-fluid" src={images[2]} alt="Book" />
            </div>
          </div>
        </div>
      );
    }

    // 4 images - grid 2x2 (default)
    return (
      <div className="row">
        <div className="col-6">
          <div className="booksv1__img--wrap">
            <div className="booksv1__img">
              <img className="img-fluid" src={images[0]} alt="Book" />
            </div>
            <div className="booksv1__img">
              <img className="img-fluid" src={images[1]} alt="Book" />
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="booksv1__img--wrap m-50px-t md-m-0px-t">
            <div className="booksv1__img">
              <img className="img-fluid" src={images[2]} alt="Book" />
            </div>
            <div className="booksv1__img">
              <img className="img-fluid" src={images[3]} alt="Book" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section
      id="books-new"
      className={`booksv1 section-padding ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span className="title">{booksNew.uptitle}</span>
              <h2 className="display-6">{booksNew.title}</h2>
            </div>
            <div className="section-title-center text-center">
              <span>{booksNew.subtitle}</span>
              <h2 className="display-6">{booksNew.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row gx-5">
          <div
            className="col-lg-6 mb-4 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            {renderImages()}
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="booksv1__contnet">
              <div className="booksv1__contnet--badge mb-0">
                {booksNew.booksItem.subtitle}
              </div>
              <h3 className="display-6 m-30px-b">{booksNew.booksItem.title}</h3>
              <div className="booksv1__item--wrap">
                {booksNew.booksItem?.booksItemContent?.map((item, i) => (
                  <div className="booksv1__item" key={i}>
                    <div className="booksv1__item--icon">
                      <img
                        className="img-fluid"
                        src={item.icon}
                        alt="Icon"
                        width="30"
                        height="30"
                      />
                    </div>
                    <div className="booksv1__item--text">
                      <h3>{item.title}</h3>
                      <div dangerouslySetInnerHTML={{ __html: item.description }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="booksv1__button">
        <a
          href={herov2New?.buyLink || "https://amzn.eu/d/i0oyx0W"}
          target="_blank"
          rel="noreferrer"
          className="smooth button button__primary me-3"
        >
          <span>{herov2New.buyBtn}</span>
        </a>
      </div>
    </section>
  );
};

export default Booksv1New;
